import { Component, AfterViewInit, OnInit, OnChanges, OnDestroy, ViewChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';

declare var $: any;


export class ChosenDropdownComponent implements OnInit, OnChanges,  AfterViewInit, OnDestroy {

	 public chosenElementRef: ElementRef;
	 public multiple: boolean = false;
	 public withoutSeparator: boolean = false;
	 public returnFullItem: boolean = false;
	 public placeholder: string = 'Select option';
	 public values: any[] = [];
	 public selectedValues: any[] = [];
	 public optionValueKey: string = '';
	 public optionLabelKey: string = '';
	 public forceDefault: boolean = false;
	 public reactOnInputChanges: boolean = false;
	 public optGroup: boolean = false;
	 public onChange = new EventEmitter<any>();

	public options: any[] = [];

	private optionsMap: any = {};
	private isLoaded: boolean = false;

	public ngOnChanges(changes: any) {
		if (!this.reactOnInputChanges || !this.isLoaded) {
			return;
		}
		if (typeof changes.selectedValues !== 'undefined') {
			this.setValue(changes.selectedValues.currentValue);
		}
	}

	public ngOnInit() {
		this.fetchValues();
	}

	public ngAfterViewInit() {
		$(this.chosenElementRef.nativeElement).val(this.selectedValues);
		$(this.chosenElementRef.nativeElement).chosen({
			width: '100%',
			search_contains: true,
		}).change((evt, change) => {
			// output: selected, deselected, default
			if (this.forceDefault === true || !change) {
				let data: string[] = $(this.chosenElementRef.nativeElement).val();
				if (this.returnFullItem) {
					data = data.map((value) => {
						if (typeof this.optionsMap[value] === 'undefined') {
							return value;
						}
						return this.optionsMap[value];
					});
				}
				this.onChange.next({default: data});
				return;
			}
			if (typeof change.selected !== 'undefined' || typeof change.deselected !== 'undefined') {

				if (this.returnFullItem && typeof this.optionsMap[change.selected] !== 'undefined') {
					change.selected = this.optionsMap[change.selected];
				}
				if (this.returnFullItem && typeof this.optionsMap[change.deselected] !== 'undefined') {
					change.deselected = this.optionsMap[change.deselected];
				}

				this.onChange.next(change);
			}
		});

		if (this.withoutSeparator) {
			$(this.chosenElementRef.nativeElement).next().children().addClass('without-separator');
		}

		this.isLoaded = true;
	}

	public setValue(value: any) {
		$(this.chosenElementRef.nativeElement).val(value).trigger('chosen:updated');
	}

	public ngOnDestroy() {
		if (this.chosenElementRef.nativeElement) {
			$(this.chosenElementRef.nativeElement).chosen('destroy');
		}
	}

	private fetchValues(): void {
		let tmpOptios = [];

		this.values.forEach((option: any) => {
			if (this.optGroup) {
				if (typeof option === 'object' && typeof option['opt_group'] !== 'undefined' && typeof option['options'] !== 'undefined') {
					let tmpOptiosItem = {
						opt_group: option['opt_group'],
						options: []
					};
					option['options'].forEach((innerOption) => {
						let valKey: string = this.optionValueKey;
						let labelKey: string = this.optionLabelKey;
						if (typeof innerOption[valKey] !== 'undefined' && typeof innerOption[valKey] !== 'undefined' ) {
							tmpOptiosItem.options.push({
								value: innerOption[valKey],
								label: innerOption[labelKey]
							});
						}
					});

					tmpOptios.push(tmpOptiosItem);
				}
			} else {
				if (typeof option === 'object') {
					// we have an array of objects
					// if the option value & option label keys are not provided the first 2 numerable properties of the object will be used
					let valKey: string = this.optionValueKey;
					let labelKey: string = this.optionLabelKey;
					if (typeof option[valKey] !== 'undefined' && typeof option[valKey] !== 'undefined') {
						tmpOptios.push({
							value: option[valKey],
							label: option[labelKey]
						});
					}

				} else {
					// we have an array of string/numbers
					if (typeof option === 'string' || typeof option === 'number') {
						tmpOptios.push({
							value: option,
							label: option
						});
					}
				}
			}
			if (this.returnFullItem) {
				const lastItem = tmpOptios[tmpOptios.length - 1];
				if (typeof lastItem['value'] !== 'undefined' && typeof lastItem['label'] !== 'undefined') {
					this.optionsMap[lastItem['value']] = lastItem;
				}
			}
		});

		this.options = [...tmpOptios];
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/chosen-dropdown/chosen-dropdown.component.ts